import styled from "styled-components";
import Title from "../Typography/Title";
import { devices } from "../../utilities/responsive";

export const FilterBar = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 10%;
  align-items: center;
  flex-wrap: wrap;
  z-index: 10;
`;

export const FilterButton = styled.button<{ isSelected: boolean }>`
  padding: 9px 18px 9px 18px;
  background: ${({ isSelected }) =>
    isSelected
      ? "linear-gradient(to right, #654ad2 0%, #2173cf 40%, #247ccc 49%, #36b1bd 100%);"
      : "transparent"};
  color: ${({ isSelected }) => (isSelected ? "white" : "#5062CD")};
  border: 1px solid #5062cd;
  cursor: pointer;
  font-family: "Nunito sans", sans-serif;
  font-weight: 800;
  font-size: 2rem;
  border-radius: 25px;
  transition: background 0.3s, color 0.3s, border 0.3s;

  &:hover {
    background: linear-gradient(
      to right,
      #654ad2 0%,
      #2173cf 40%,
      #247ccc 49%,
      #36b1bd 100%
    );
    color: white;
    border: 1px solid transparent;
  }

  &:focus {
    outline: none;
  }
`;
